(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fw-mr-suitcase-easter-egg"] && !Shopify.designMode) return;
  try {
    (() => {
  function placeSuitcase() {
    if (document.querySelector('.fw-newsletter-mascot, .fw-footer-mascot')) return;
    const template = document.getElementById('fw-mr-suitcase-template');
    const newsletter = document.querySelector('.newsletter__wrapper');
    const footer = document.querySelector('footer .footer__content-bottom') || document.querySelector('footer');
    if (!template || (!newsletter && !footer)) return;
    const sticker = template.content.firstElementChild.cloneNode(true);
    if (newsletter) {
      sticker.className = 'fw-newsletter-mascot';
      newsletter.append(sticker);
    } else {
      sticker.className = 'fw-footer-mascot';
      const wrap = document.createElement('div');
      wrap.className = 'fw-footer-mascot-wrap';
      wrap.append(sticker);
      footer.append(wrap);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeSuitcase, { once: true });
  } else {
    placeSuitcase();
  }
  document.addEventListener('shopify:section:load', placeSuitcase);
})();
  } catch(e) { console.error(e); }
})();

})();
